import { ErrorResponseError } from '../error.ts';
import type { HttpStatusCode } from '../../../types/web/http';
import { EMPTY_HTTP_HEADERS } from '../../http/headers.ts';

export class ResponseStatusError extends ErrorResponseError {
    readonly #reason?: string;

    constructor(status: HttpStatusCode, reason?: string) {
        super(status, ResponseStatusError.problemDetailFor(status, reason));
        this.#reason = reason;
    }

    get reason() {
        return this.#reason;
    }

    get headers() {
        return EMPTY_HTTP_HEADERS;
    }
}
